import * as cookieBanner from "./cookie-banner";
export * from "./typings/interface";
var src_default = cookieBanner;
export {
  src_default as default
};
